/**
 * Shop Switch Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Shop Switch module.
 *
   * @namespace CartUpsaleItem
 */

 theme.CartUpsaleItem = (function() {
   function CartUpsaleItem(container) {
     var $container = this.$container = $(container);
     var sectionId = $container.attr('data-section-id');

     if (_.isUndefined($container.data('upsale-products'))) {
       return;
     };

     this.data = {
       products: JSON.parse($container.data('upsale-products')),
       inCart: $container.data('variants-cart').split(',')
     };
     var self = this;
     var select = document.getElementById('upsaleCheckBox');
     var showbox = document.getElementById("box");

     const inCart = this.data.inCart.map(x => x * 1);

     var itemsToRemove = false;
      if($(select).is(':checked')){
           itemsToRemove = true;
           showbox.classList.add("show");
      }


    /* Gets a reference to the form element */
    var form = document.getElementById('upsaleTextarea');

    // Adds a listener for the "submit" event.
    /*form.addEventListener('submit', function(e) {
      // Prevents the default input from being submitted
      e.preventDefault();

    }); */
      /*
    // Append & Prepend the input before submitting
    $('.Cart__Checkout').click(function () {
        $('.Cart__Note').map(function () {
            $(this).val($(this).prepend('#cb#').append('#ce#');
            alert($(this).val());
        });
    });
    */

    $(select).click(function() {

     if (itemsToRemove) {
        //this.removeFromCart(this.data.products[0].product);
        Shopify.changeItem(self.data.products[0].product, 0, function(data) {
          window.location.reload();

        });
      }
    });
     const handleChange = (ev) => {

       if (!itemsToRemove) {
         if($(select).is(':checked')){

             Shopify.addItem(this.data.products[0].product, 1, function(data) {
               window.location.reload();

             });
             var itemsToRemove = true;
         }
       }
     }



     select.addEventListener( 'change', (ev) => {
       handleChange(ev);
     });

     $(document).on('cart:loaded', (detail) => {
        select = document.getElementById('upsaleCheckBox');
        select.addEventListener( 'change', (ev) => {
          handleChange(ev);
        });
     });

     window.CartUpsaleItem = this;

   }

   CartUpsaleItem.prototype = $.extend({}, CartUpsaleItem.prototype, {

     addToCart: function(variable) {
       // TODO: Disable checkbox when adding
       $(document).ready(function() {

         console.log(CartUpsaleItem);
         Shopify.addItem(variable, 1, function(data) {
           // window.location.reload();
           console.log(data);
         });
       });
       console.log('Adding product to cart: ' + variable);
       Shopify.addItem(variable, 1, function(data) {
         // window.location.reload();
         console.log(data);
       });
     },

     removeFromCart: function(variable) {
       // TODO: Disable checkbox when adding
       console.log('Removing product from cart: ' + variable);
       Shopify.changeItem(variable, 0, function(data) {
         console.log(data);
       });
     },

     onLoad: function() {
       console.log('load');
     },

     onSelect: function() {
       console.log('select');
     },

     onDeselect: function() {
     },

     onBlockSelect: function(event) {
     },

     onBlockDeselect: function(event) {
     },

     onUnload: function() {

     }
   });

   return CartUpsaleItem;
 })();
